import React from 'react';
import { Icon } from './Icon.js';
export const IconRadioUncheckedFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("circle", { cx: "6", cy: "6", r: "6", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconRadioUncheckedFill12.js.map